export const DS_PRODUCT = 'dsProduct'
export const PD_PRODUCT = 'pdProduct'
export const MS_PRODUCT = 'msProduct'
export const CS_PRODUCT = 'csProduct'
export const PD_REVIEW_PRODUCT = 'pdReviewProduct' // 리뷰 상세
